import { Injectable, Inject } from '@angular/core';
import { Http } from '@angular/http';
 import * as models from '../swagger/ecomApi';
 import { EanerClient } from '../swagger/ecomApi';
 import { Observable } from '../../../node_modules/rxjs';
 import { ApiConfig } from '../../shared/api-config.service';
 import { LoggerService } from '../../shared/logger.service';
 import { Storage } from '@ionic/storage';
import 'rxjs/Rx';


@Injectable()
export class ecomUserApi extends EanerClient {
    className: string = "ecomUserApi";
    savedAccessToken: any;
    

    constructor( @Inject(Http) http: Http, protected apiConfig: ApiConfig, private log: LoggerService, private storage: Storage) {
        super(http, apiConfig.apiBaseForum);
     }


    CreateEarner(earner: models.CreateEarnerRequest | null): Observable<boolean>{
        return this.createEarner(earner);
    }

    Login(model: models.LoginModel | null): Observable<models.LoginResult> {
        return this.login(model);
    } 

    public saveLoginToken( result : models.LoginResult){
        this.log.debug('Api saveLoginToken - accessToken ' + result.token);

        this.storage.set('accessToken', result.token);
        this.storage.set('name', result.name);
        this.storage.set('role', result.roles);
        this.storage.set('userId', result.userId);

        if(result.roles.length <= 1){
            this.storage.set('currentRole', result.roles);
        }

        this.savedAccessToken = result.token;
    }

    public isAuth(){
        this.storage.get('accessToken').then((accessToken) => {
            this.savedAccessToken = accessToken; 
            return this.savedAccessToken;
        });
        return null;
    }

}




// WEBPACK FOOTER //
// ./src/api/ecom/ecomUserApi.ts